// extracted by mini-css-extract-plugin
module.exports = {"box":"show-qrcode_box_2m1gW","image":"show-qrcode_image_3ijtq","btnGroup":"show-qrcode_btnGroup_19GgI"};